/** The address shape every email form on the site accepts. ASCII only, so a
 *  non-ASCII address is refused by this check too. */
const EMAIL_SHAPE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const isEmailShape = (value: string): boolean => EMAIL_SHAPE.test(value);
